import { render } from "./DragDropNotification.vue?vue&type=template&id=adaf9284&scoped=true"
import script from "./DragDropNotification.vue?vue&type=script&lang=js"
export * from "./DragDropNotification.vue?vue&type=script&lang=js"

import "./DragDropNotification.vue?vue&type=style&index=0&id=adaf9284&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adaf9284"]])

export default __exports__